import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { BaseDataService, BaseUpdateComponent, NotificationService } from 'yt-ng-framework';
import { KomitentUgovor } from './komitent-ugovor';
import { KomitentUgovorStavka } from './komitent-ugovor-stavka';
import { Subscription } from 'rxjs';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-komitent-ugovor-stavka-update',
  templateUrl: './komitent-ugovor-stavka-update.component.html'
})
export class KomitentUgovorStavkaUpdateComponent extends BaseUpdateComponent<KomitentUgovorStavka> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) { 
    super(activatedRoute,baseDataService,toastrService,translateService);
  }

  komitentUgovorID: number;
  private ugovorenaCenaSubscription: Subscription;
  private ugovorenaVrednostSubscription: Subscription;
  private ugovorenaKolicinaSubscription: Subscription;

  ngOnInit() {
    super.ngOnInit();
   // this.addValidatorToFc("KomitentUgovorID", Validators.required, 'required', 'KOMITENTUGOVORSTAVKA.KOMITENTUGOVORID.VALIDATION.REQUIRED');  
    this.addValidatorToFc("UgovorenaKolicina", Validators.required, 'required', 'KOMITENTUGOVORSTAVKA.UGOVORENAKOLICINA.VALIDATION.REQUIRED');  
    this.addValidatorToFc("UgovorenaJedinicaMereId", Validators.required, 'required', 'KOMITENTUGOVORSTAVKA.UGOVORENAJEDINICAMERE.VALIDATION.REQUIRED');
    this.addValidatorToFc("UgovorenaCena", Validators.required, 'required', 'KOMITENTUGOVORSTAVKA.UGOVORENACENA.VALIDATION.REQUIRED');
    this.addValidatorToFc("UgovorenaVrednostValutaId", Validators.required, 'required', 'KOMITENTUGOVORSTAVKA.UGOVORENAVREDNOSTVALUTA.VALIDATION.REQUIRED');
    this.addValidatorToFc("CenaDodatnogPosla", Validators.required, 'required', 'KOMITENTUGOVORSTAVKA.CENADODATNOGPOSLA.VALIDATION.REQUIRED');
    //this.addValidatorToFc("CenaDodatnogPoslaValutaId", Validators.required, 'required', 'KOMITENTUGOVORSTAVKA.CENADODATNOGPOSLAVALUTA.VALIDATION.REQUIRED'); 

    this.baseFormGroup.setValidators(CheckValutaDodatnogPosla('CenaDodatnogPosla', 'CenaDodatnogPoslaValutaId'));
    this.baseFormGroup.updateValueAndValidity();

    // this.ugovorenaCenaSubscription = this.baseFormGroup.get("UgovorenaCena").valueChanges.subscribe((value)=>{
    //   if (this.baseFormGroup.get("UgovorenaKolicina").value != null){
    //     let ugovorenaVrednost = value * this.baseFormGroup.get("UgovorenaKolicina").value;
    //     if(ugovorenaVrednost != this.baseFormGroup.get("UgovorenaVrednost").value){
    //       this.baseFormGroup.patchValue({UgovorenaVrednost: ugovorenaVrednost});
    //       this.baseFormGroup.get("UgovorenaVrednost").updateValueAndValidity();
    //     }
    //   }
    // })

    // this.ugovorenaVrednostSubscription = this.baseFormGroup.get("UgovorenaVrednost").valueChanges.subscribe((value)=>{
    //   if (this.baseFormGroup.get("UgovorenaKolicina").value != null && this.baseFormGroup.get("UgovorenaKolicina").value != 0){
    //     let ugovorenaCena = value /this.baseFormGroup.get("UgovorenaKolicina").value;
    //     if(ugovorenaCena != this.baseFormGroup.get("UgovorenaCena").value)
    //     {
    //       this.baseFormGroup.patchValue({UgovorenaCena: ugovorenaCena});
    //       this.baseFormGroup.get("UgovorenaCena").updateValueAndValidity();
    //     }        

    //   }
    // })

    // this.ugovorenaKolicinaSubscription = this.baseFormGroup.get("UgovorenaKolicina").valueChanges.subscribe((value)=>{
    //   if(this.baseFormGroup.get("UgovorenaCena").value!=0){
    //     let ugovorenaVrednost = value * this.baseFormGroup.get("UgovorenaCena").value
    //     if(ugovorenaVrednost != this.baseFormGroup.get("UgovorenaVrednost").value){
    //       this.baseFormGroup.patchValue({UgovorenaVrednost: ugovorenaVrednost});
    //       this.baseFormGroup.get("UgovorenaVrednost").updateValueAndValidity();
    //     }
    //   }
    // })
  }

  ngOnDestroy(){
    super.ngOnDestroy();
    if (this.ugovorenaCenaSubscription)
    {
      this.ugovorenaCenaSubscription.unsubscribe();
    }

    // if (this.ugovorenaVrednostSubscription)
    //   {
    //     this.ugovorenaVrednostSubscription.unsubscribe();
    //   }
  }

  onKomitentUgovorSelect(value: KomitentUgovor){
    this.komitentUgovorID = value.ID
  }

}

function CheckValutaDodatnogPosla(cenaDodatnogPoslaKey:string, CenaDodatnogPoslaValutaId: string){
  return (group: FormGroup): {[key : string]: any} =>{
   let cenaDodatnogPosla = group.controls[cenaDodatnogPoslaKey].value;
   let cenaDodatnogPoslaValutaId = group.controls[CenaDodatnogPoslaValutaId].value;

   if (cenaDodatnogPosla==null)
       return null;
   else{
       if (cenaDodatnogPosla > 0 && cenaDodatnogPoslaValutaId == null)
           return { checkControls :{valid:false, message: 'KOMITENTUGOVORSTAVKA.CENADODATNOGPOSLAVALUTA.VALIDATION.REQUIRED'}};
       }  
   }    
}